import React from "react";
import packageJson from "../../../package.json";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer_container">v{packageJson.version}</div>
    </footer>
  );
}
